import React from "react";
import "./CustomButton.css";

const CustomBotton = ({ children, ...attributes }) => {
  return (
    <div className="buttonStyle" type="submit" {...attributes}>
      {children}
    </div>
  );
};

export default CustomBotton;
